
export default {
    // i18n of Sidebar.vue
    "sidebar.photo_library": "Library",
    "sidebar.recent": "Recent",
    "sidebar.favorites": "Favorites",
    "sidebar.people.title": "People {0}",
    "sidebar.shared_album": "Shared Album",

    // i18n of Content.vue
    "content.photo_count": "{0} Photos",
    "content.ctx_menu.zoom_in": "Zoom In",
    "content.ctx_menu.zoom_out": "Zoom Out",
    "content.ctx_menu.default_scale": "Default Scaling (Current: {0})",
    "content.ctx_menu.share": "Share...",
    "content.ctx_menu.export_fav": "Export Favorites",
    "content.ctx_menu.import_fav": "Import Favorites",

    "content.share_dialog.title": "Share Album",
    "content.share_dialog.sharing": "Sharing: ",
    "content.share_dialog.set_password_label": "Set password for sharing:",
    "content.share_dialog.share_btn": "Share",
    "content.share_dialog.share_link_is": "The permalink is:",
    "content.share_dialog.share_link_desc_1": "Send this link to others to share the album without providing them with the album access password.\nThe person who gets the sharing link needs to enter the sharing password before they can view it.",
    "content.share_dialog.share_link_desc_2": "If you want to revoke the access rights, please use the tools provided by this project to regenerate the sharing API.",
    "content.share_dialog.unsharable": "You can't share this album.",

    "content.fav.unsupported": "This feature is unavailable because your browser does not support Local Storage.",
    "content.fav.unrecognized": "The selected file is not recognized!",

    // i18n of PopupDialog.vue
    "popup.complete_btn": "Complete",

    // i18n of PasswordInput.vue
    "pwdi.title": "Album",
    "pwdi.hint": "Please input password to access the albums.",
    "pwdi.retry": "Password is incorrect, please try again!",

    // i18n of Preview.vue
    "preview.loading": "Loading image...",
    "preview.download_btn": "Download",
    "preview.zoom_in": "Zoom In",
    "preview.zoom_out": "Zoom Out",
    "preview.zoom_percent": "Zoom Percent",
    "preview.reset_zoom": "Reset",
    "preview.prev_photo": "Previous (Left Arrow Key)",
    "preview.next_photo": "Next (Right Arrow Key)",

    // i18n of Settings.vue
    "Settings": "Settings",
    "General": "General",
    "Language": "Language",
    "About": "About",
    "Close": "Close",
    "settings.language_hint": "The page will automatically refresh after changing the language.",
    "settings.license": "Licensed: MIT License",
}